/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamAnalysisWorkResultDtoOutput } from './BeamAnalysisWorkResultDtoOutput';
import {
    BeamAnalysisWorkResultDtoOutputFromJSON,
    BeamAnalysisWorkResultDtoOutputFromJSONTyped,
    BeamAnalysisWorkResultDtoOutputToJSON,
} from './BeamAnalysisWorkResultDtoOutput';
import type { BeamAnalysisWorkResultDtoCorrections } from './BeamAnalysisWorkResultDtoCorrections';
import {
    BeamAnalysisWorkResultDtoCorrectionsFromJSON,
    BeamAnalysisWorkResultDtoCorrectionsFromJSONTyped,
    BeamAnalysisWorkResultDtoCorrectionsToJSON,
} from './BeamAnalysisWorkResultDtoCorrections';
import type { BeamAnalysisWorkResultDtoCreatorUser } from './BeamAnalysisWorkResultDtoCreatorUser';
import {
    BeamAnalysisWorkResultDtoCreatorUserFromJSON,
    BeamAnalysisWorkResultDtoCreatorUserFromJSONTyped,
    BeamAnalysisWorkResultDtoCreatorUserToJSON,
} from './BeamAnalysisWorkResultDtoCreatorUser';
import type { ResultState } from './ResultState';
import {
    ResultStateFromJSON,
    ResultStateFromJSONTyped,
    ResultStateToJSON,
} from './ResultState';

/**
 * 
 * @export
 * @interface BeamAnalysisWorkResultDto
 */
export interface BeamAnalysisWorkResultDto {
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisWorkResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisWorkResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {ResultState}
     * @memberof BeamAnalysisWorkResultDto
     */
    state?: ResultState;
    /**
     * 
     * @type {BeamAnalysisWorkResultDtoOutput}
     * @memberof BeamAnalysisWorkResultDto
     */
    output?: BeamAnalysisWorkResultDtoOutput | null;
    /**
     * 
     * @type {BeamAnalysisWorkResultDtoCreatorUser}
     * @memberof BeamAnalysisWorkResultDto
     */
    creatorUser?: BeamAnalysisWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkResultDto
     */
    measurementId?: string | null;
    /**
     * 
     * @type {BeamAnalysisWorkResultDtoCorrections}
     * @memberof BeamAnalysisWorkResultDto
     */
    corrections?: BeamAnalysisWorkResultDtoCorrections | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkResultDto
     */
    $type?: BeamAnalysisWorkResultDtoTypeEnum;
}


/**
 * @export
 */
export const BeamAnalysisWorkResultDtoTypeEnum = {
    PtwPtw100BeamAnalysisApplicationJobExecutionDtoBeamAnalysisWorkResultDtoPtwPtw100BeamAnalysisApplication: 'Ptw.Ptw100.BeamAnalysis.Application.JobExecution.Dto.BeamAnalysisWorkResultDto, Ptw.Ptw100.BeamAnalysis.Application'
} as const;
export type BeamAnalysisWorkResultDtoTypeEnum = typeof BeamAnalysisWorkResultDtoTypeEnum[keyof typeof BeamAnalysisWorkResultDtoTypeEnum];



/**
 * Check if a given object implements the BeamAnalysisWorkResultDto interface.
 */
export function instanceOfBeamAnalysisWorkResultDto(value?: unknown): value is BeamAnalysisWorkResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamAnalysisWorkResultDtoTypeEnum)[0];
}

export function BeamAnalysisWorkResultDtoFromJSON(json: any): BeamAnalysisWorkResultDto {
    return BeamAnalysisWorkResultDtoFromJSONTyped(json, false);
}

export function BeamAnalysisWorkResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisWorkResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'state': json['state'] == null ? undefined : ResultStateFromJSON(json['state']),
        'output': json['output'] == null ? undefined : BeamAnalysisWorkResultDtoOutputFromJSON(json['output']),
        'creatorUser': json['creatorUser'] == null ? undefined : BeamAnalysisWorkResultDtoCreatorUserFromJSON(json['creatorUser']),
        'measurementId': json['measurementId'] == null ? undefined : json['measurementId'],
        'corrections': json['corrections'] == null ? undefined : BeamAnalysisWorkResultDtoCorrectionsFromJSON(json['corrections']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamAnalysisWorkResultDtoToJSON(value?: Omit<BeamAnalysisWorkResultDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'state': ResultStateToJSON(value['state']),
        'output': BeamAnalysisWorkResultDtoOutputToJSON(value['output']),
        'creatorUser': BeamAnalysisWorkResultDtoCreatorUserToJSON(value['creatorUser']),
        'measurementId': value['measurementId'],
        'corrections': BeamAnalysisWorkResultDtoCorrectionsToJSON(value['corrections']),
        '$type': value['$type'],
    });
}

